import React from "react";
import { useSelector } from "react-redux";
import { FiInstagram, FiMail } from "react-icons/fi";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
const LandingFooter = () => {
  const translation = useSelector((state) => state.translation);

  return (
    <footer className="landing-footer">
      <div className="landing-container footer-grid">
        <div className="footer-brand">
          <div className="footer-logo">
            <img
              src="https://pub-uploads.s3.amazonaws.com/uploads/chat/web/dk4JN4AVx9_esyncing-logo.png"
              alt="eSyncing"
            />
          </div>
          <p>{translation.landing_footer_tagline || "AI-powered platform for teams and customers."}</p>
        </div>
        <div className="footer-col">
          <h5>{translation.landing_footer_product || "Product"}</h5>
          <a href="#features">{translation.landing_footer_product_item1 || "Interactive Demos"}</a>
          <a href="#demo">{translation.landing_footer_product_item2 || "AI-Powered Chat"}</a>
          <a href="#demo">{translation.landing_footer_product_item3 || "Virtual HR Assistant"}</a>
          <a href="#demo">{translation.landing_footer_product_item4 || "Knowledge Hub"}</a>
          <a href="#demo">{translation.landing_footer_product_item5 || "Integrations"}</a>
        </div>
        <div className="footer-col">
          <h5>{translation.landing_footer_use_cases || "Use Cases"}</h5>
          <a href="#features">{translation.landing_footer_use_cases_item1 || "Real Estate"}</a>
          <a href="#features">{translation.landing_footer_use_cases_item2 || "E-commerce"}</a>
          <a href="#features">{translation.landing_footer_use_cases_item3 || "Corporate"}</a>
          <a href="#features">{translation.landing_footer_use_cases_item4 || "Customer Support"}</a>
        </div>
        <div className="footer-col">
          <h5>{translation.landing_footer_company || "Company"}</h5>
          <a href="/contact-us">{translation.landing_footer_company_item1 || "Contact Us"}</a>
          <a href="/privacy-policy">{translation.landing_footer_company_item2 || "Privacy Policy"}</a>
          <a href="/terms-conditions">{translation.landing_footer_company_item3 || "Terms & Conditions"}</a>
          <a href="/cookie-policy">{translation.landing_footer_company_item4 || "Cookie Policy"}</a>
        </div>
      </div>
      <div className="footer-divider" />
      <div className="landing-container footer-bottom">
        <span>{translation.landing_footer_copyright || "© 2026 eSyncing. All rights reserved."}</span>
        <div className="footer-socials">
          <span><FiInstagram /></span>
          <span><FiMail /></span>
          <span><FaLinkedinIn /></span>
          <span><FaXTwitter/></span>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;

